const styles = theme => ({
  formDescription: {
    fontSize: '14px',
  },
  boxForm: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-between',
    },
  },
  numericFieldWrapper: {
    minWidth: '200px',
    width: '200px',
    '& .MuiInputBase-root': {
      fontSize: '14px',
    },
  },
});

export default styles;
